// ===========================================
// Calendar Integration Page (OAuth Callback)
// ===========================================
// Lightweight page for Google Calendar OAuth callback.
// Handles the OAuth redirect and redirects to Account Settings.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { extractSchoolSlugFromPath } from '../../utils/routing';

export default function CalendarIntegrationPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const schoolSlug = extractSchoolSlugFromPath(window.location.pathname);

    if (schoolSlug) {
      // Redirect to account settings with school slug
      // This page was reached after successful OAuth callback
      navigate(`/${schoolSlug}/teacher/account`, { replace: true });
    } else {
      // Fallback for missing school slug (shouldn't happen)
      navigate('/teacher/account', { replace: true });
    }
  }, [navigate]);

  // Show nothing while redirecting
  return null;
}
